import { useQuery } from "@tanstack/react-query"
import { getContactosById } from "api/Contacto.service"
import DatosAvanzados from "features/Contactos/components/DatosAvanzados"
import DatosBasicos from "features/Contactos/components/DatosBasicos"
import EditarContactoHeader from "features/Contactos/components/EditarContactoHeader"
import { useParams } from "react-router-dom"

const EditarContacto = () => {
  const { id } = useParams<{ id: string }>()

  const { data: contactoById, refetch: contactoByIdRefetch } = useQuery({
    queryKey: ["contactoById", id],
    enabled: Boolean(id),
    queryFn: () => getContactosById(id ?? ""),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  return (
    <div className='tw-overflow-hidden tw-h-full'>
      <EditarContactoHeader contacto={contactoById} />
      <div className='tw-flex-row tw-flex tw-h-[calc(100%-70px)] tw-overflow-hidden'>
        <DatosBasicos
          contacto={contactoById}
          contactoByIdRefetch={contactoByIdRefetch}
        />
        {contactoById && (
          <DatosAvanzados
            contactoById={contactoById}
            updateContactoById={contactoByIdRefetch}
          />
        )}
      </div>
    </div>
  )
}

export default EditarContacto
